import { lazy } from 'react';

export const ForgotPassword = lazy(() => import('./ForgotPassword.component'));
